import { createAuthInstance } from './general'

const identityHost = process.env.VUE_APP_IDENTITY_API_HOST

export const getUserInfo = async () => {
  return createAuthInstance(identityHost).get('me/info')
}

// export const getTenantServices = async () => {
// TODO:return createAuthInstance(identityHost).get('tenantservice')
// return { 'status': 200 , 'data': [] }
//   return createAuthInstance(identityHost).get('tenantservice')
// }
